import Person from './person.js';

export default class Sacrificer extends Person
{
    constructor(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note)
    {
        super(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note);
        
        // Related Data to Sacrificer
        this.employmentRecord   = null;
        this.previousEmployment = null;
        this.administrativeData = null;
    }

    setEmploymentRecord(employmentRecord){
        this.employmentRecord = employmentRecord
        return this
    }

    setPreviousEmployment(previousEmployment){
        this.previousEmployment = previousEmployment
        return this
    }

    setAdministrativeData(administrativeData){
        this.administrativeData = administrativeData
        return this
    }
}

